<template>
  <b-col class="col-12">
    <b-alert
      show
      :variant="localComentario.edit ? 'warning' : 'success'"
      v-if="isVisibleForm"
      class="row d-flex align-items-center"
      style="margin: 0 0px; padding: 12px 10px"
    >
      <div class="col-11 p-0">
        <small
          class="d-block text-right"
          :class="localComentario.edit ? 'text-danger' : 'text-success'"
        >
          {{ localComentario.edit ? "No guardado" : "Guardado" }}
        </small>
        <b-form-input
          v-if="isVisibleForm"
          v-model="localComentario.text"
          size="sm"
          :disabled="!localComentario.edit"
          :state="!localComentario.edit"
        />
      </div>

      <div v-if="isVisibleForm" class="col-1">
        <div style="visibility: hidden">a</div>
        <b-button
          v-if="localComentario.edit"
          size="sm"
          variant="outline-info"
          @click="onSaveComment"
          :disabled="!localComentario.text"
        >
          <i class="fa-solid fa-floppy-disk" />
        </b-button>

        <b-button
          v-if="!localComentario.edit && isJefeMedico"
          size="sm"
          variant="outline-secondary"
          @click="
            () => {
              localComentario.edit = true;
            }
          "
        >
          <i class="fa-solid fa-pen" />
        </b-button>
      </div>
    </b-alert>

    <div style="position: absolute; top: -30px; right: 10px">
      <b-button size="sm" v-if="!this.isVisibleForm && isJefeMedico" @click="onShowForm">
        <i class="fas fa-comment" title="Auditar" />
      </b-button>

      <b-button
        v-if="this.isVisibleForm && isJefeMedico"
        size="sm"
        variant="danger"
        @click="onRemoveComment"
      >
        <i class="fa-solid fa-comment-slash" />
      </b-button>
    </div>
  </b-col>
</template>

<script>
import { atencionAuditoriaService } from "../../services";
import { ROLES } from "../../../../shared/constants";
import { comprobarRoles } from "../../../../shared/helpers";
import { isJefeMedico } from "../../../derivaciones/helpers";

export default {
  name: "CommentEditor",

  props: {
    field: {
      type: String,
      required: true,
    },
    odonto: {
      type: Boolean,
      required: false,
      default:false
    },

    initialValue: {
      // si quieres precargar el comentario
      type: String,
      default: null,
    },
  },

  data() {
    return {
      atencionAuditoriaService,
      isVisibleForm: false,

      localComentario: {
        edit: true,
        text: this.initialValue,
      },
    };
  },
  computed:{
 isJefeMedico() {
      return comprobarRoles([
        ROLES.JEFE_MEDICO,
        ROLES.JEFE_VALIDACIONES,
        ROLES.JEFE_AUDITOR,
        ROLES.JEFE_DERIVADOR,
      ]);
    },
  },

  watch: {
    "$route.query.view_atencion": {
      immediate: true,
      deep: true,
      async handler(newValue) {
        const result =
          await atencionAuditoriaService.consultarComentariosAuditoria(
            newValue
          );

        
        let comentarios = {};

        try {
          comentarios = result?.comentariosauditoria
            ? JSON.parse(result.comentariosauditoria)
            : {};

         console.log("COMENTARIOS", comentarios)


          
        } catch (err) {
          comentarios = {};
        }

        if (comentarios[newValue]) {

              const obj = comentarios[newValue];

Object.entries(obj).forEach(([field, text]) => {
   this.$store.commit("addComentarioAuditoria", {
        token: newValue,
        field: field,
        comentario: text,
      });
});
              console.log("coasda", comentarios[newValue][this.field])
             if (comentarios[newValue][this.field]) {
               this.localComentario.text = comentarios[newValue][this.field];
               this.localComentario.edit = false; 
               this.isVisibleForm = true;
             }
           }

        // try {
        //   let comentarios = JSON.parse(result.comentariosauditoria);
        //   if (comentarios[newValue]) {
        //     if (comentarios[newValue][this.field]) {
        //       this.localComentario.text = comentarios[newValue][this.field];
        //     }
        //   }
        // } catch (error) {
        //   console.log("error", error);
        // }

        
      },
    },
  },

  methods: {
    onShowForm() {
      this.isVisibleForm = !this.isVisibleForm;
    },

    onEditComment() {
      this.localComentario.edit = true;
    },

    onSaveComment() {
      const tokenAtencion = this.$route.query.view_atencion;
      this.localComentario.edit = false;

      if (!this.localComentario.text) return;

      this.$store.commit("addComentarioAuditoria", {
        token: tokenAtencion,
        field: this.field,
        comentario: this.localComentario.text,
      });
    },

    onRemoveComment() {
      const tokenAtencion = this.$route.params.token;
      this.isVisibleForm = false;
      this.localComentario = { edit: true, text: null };

      this.$store.commit("removeComentarioAuditoria", {
        token: tokenAtencion,
        field: this.field,
      });
    },
  },
};
</script>

<style></style>
